export const getStorage = () => {
  let user = null;
  const stored_user = localStorage.getItem('user');
  if (stored_user) {
    user = JSON.parse(stored_user);
  }
  if (user) {
    return user;
  }
  return {};
};

export const deleteStorage = () => {
  localStorage.setItem('user', '{}');
};

export const getSettings = () => {
  let settings = null;
  const stored_settings = localStorage.getItem('settings');
  if (stored_settings) {
    settings = JSON.parse(stored_settings);
  }
  if (settings) {
    return settings;
  }
  return {};
};
